import axios from "axios";
import https from "https";
import * as hotelService from "./hotel.api";
import * as flightService from "./flight.api";
import * as transferService from "./transfer.api";
import * as rentacarService from "./rentacar.api";
import * as financeService from "./finance.api";
import * as orderService from "./order.api";
import * as taskService from "./task.api";
import * as userService from "./user.api";
import * as customerService from "./customer.api";
import * as globalService from "./global.api";
import * as tasklistService from "./tasklist.api";
import * as notesService from "./notes.api";
import * as dashboardService from "./dashboard.api";
import * as documentService from "./documents.api";
import * as agencyService from "./agency.api";
import * as reportService from "./report.api";
import * as announcementService from "./announcement.api";

import TokenService from "./token.api";
// import AutocompleteService from "./autocomplete.api";
// import FlightAutocompleteService from "./flightautocomplete.api";

// import moment from "moment";
import router from "@/router/index.js";
import { logger } from "@/helper/logger.js";
import store from "@/store/index.js";
import { generateUuid } from "@/utils";

const REFRESH_TOKEN_ENDPOINT = "/api/user/refreshjwt";

export var AUTH_HTTP = axios.create({
   baseURL: process.env.VUE_APP_API_URL,
   timeout: process.env.VUE_AXIOS_TIMEOUT,
   headers: {
      Authorization: `Bearer ${TokenService.getJwtToken()}`,
      "Reisetech-Version": process.env.PACKAGE_VERSION,
   },
   httpAgent: new https.Agent({
      rejectUnauthorized: false,
   }),
});

export var PUBLIC_HTTP = axios.create({
   baseURL: process.env.VUE_APP_API_URL,
   timeout: process.env.VUE_AXIOS_TIMEOUT,
   headers: {
      "Reisetech-Version": process.env.PACKAGE_VERSION,
   },
   httpAgent: new https.Agent({
      rejectUnauthorized: false,
   }),
});

export function PRIVATE_HTTP(timeout) {
   var privateHttpCreator = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      timeout: timeout ? timeout : process.env.VUE_AXIOS_TIMEOUT,
      headers: {
         Authorization: `Bearer ${TokenService.getJwtToken()}`,
         "Reisetech-Version": process.env.PACKAGE_VERSION,
      },
      httpAgent: new https.Agent({
         rejectUnauthorized: false,
      }),
   });

   privateHttpCreator.interceptors.request.use(async (config) => {
      //CHECK THIS STATEMENT TODO
      if (config.url == REFRESH_TOKEN_ENDPOINT) {
         return config;
      }
      const data = config.data;

      if (TokenService.isJwtExpired()) {
         const refreshTokenRequestModel = {
            jwt: TokenService.getJwtToken(),
            refreshToken: TokenService.getRefreshToken(),
         };
         const refreshTokenResp = await userService.refreshToken(refreshTokenRequestModel);

         TokenService.setJwtInfo(refreshTokenResp.jwt, refreshTokenResp.jwtDuration, refreshTokenResp.jwtRefreshToken);
         config.headers = {
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${TokenService.getJwtToken()}`,
         };
      }
      //GTS_UUID : header for tracking request
      if (data.uuid) config.headers["GTS-UUID"] = data.uuid;
      else config.headers["GTS-UUID"] = generateUuid();

      return config;
   });

   privateHttpCreator.interceptors.response.use(
      function (response) {
         return response;
      },
      function (error) {
         if (error.response && error.response.status === 401) {
            if (error && error.config && error.config.url != REFRESH_TOKEN_ENDPOINT) logger.error("UnExpected Unauthorized Error", error);

            TokenService.delJwtInfo();

            var currentPath = window.location.pathname;
            if (currentPath == "/login") return;
            else router.push({ path: "/login", query: { returnUrl: currentPath } });
            return new Promise(() => {
               return false;
            });
         }

         logger.error("Axios handle exception", error);

         store.commit("app/setIsProgressGifActive", false);

         // handle error
         if (error.message && error.stack) {
            error.data = {
               uuid: "",
               result: {
                  success: false,
                  app: "AGENT_SPA",
                  service: "AXIOS",
                  code: "EXCEPTION_AXIOS",
                  subCode: error.message,
                  message: error.stack,
               },
            };
         } else {
            error.data = {
               uuid: "",
               result: {
                  success: false,
                  app: "AGENT_SPA",
                  service: "AXIOS",
                  code: "EXCEPTION_AXIOS",
                  subCode: "",
                  message: "",
               },
            };
         }

         return error;
      }
   );

   return privateHttpCreator;
}

export {
   hotelService,
   flightService,
   transferService,
   rentacarService,
   financeService,
   orderService,
   taskService,
   userService,
   customerService,
   globalService,
   TokenService,
   tasklistService,
   notesService,
   dashboardService,
   documentService,
   agencyService,
   reportService,
   announcementService,
};
